module.exports = __webpack_public_path__ + "static/media/Favorites_Icon_Inactive@3x.719595b9.png";